import React, { useState, useEffect } from 'react';
import DataTable from '../../../interfaccia/DataTableBase';
import ApriElementoDiLista from '../../../interfaccia/tasti/ApriElementoDiLista';

function ListaContatti({
  mobile,
  utente,
  lista,
  apriElemento,
  loading
}) {

  const [rows, setRows] = useState(
    lista
  )

  useEffect(() => {
    setRows(lista)
  }, [lista]);

  const colonnaUniversale = function (nomeDato, labelDato, width, sortable, hide, reorder, conditionalCellStyles, ignoreRowClick, sortField, compact) {
    return ({
      selector: row => row[nomeDato],
      name: labelDato,
      sortable: sortable,
      hide: hide,
      reorder: reorder,
      width: width + "px",
      conditionalCellStyles: conditionalCellStyles,
      ignoreRowClick: ignoreRowClick,
      sortField: sortField,
      compact: compact
    })
  }

  const colonnaBoolean = function (nomeDato, labelDato, width, icon1, icon0, sortField, colIcon1, colIcon0, cellStyles, noCompact) {
    return ({
      selector: row => row[nomeDato],
      name: labelDato,
      sortable: true,
      sortField: sortField,
      reorder: true,
      compact: noCompact ? false : true,
      width: width + "px",
      conditionalCellStyles: cellStyles,
      format: (row) => {
        if (row[nomeDato] == null || row[nomeDato] === 0) { return <div class={"rowitem material-icons nonSelezionabile " + colIcon0}>{icon0}</div> }
        else { return <div class={"rowitem material-icons " + colIcon1}>{icon1}</div> }
      }
    }
    )
  }

  const arrayACapo = function (nomeDato, labelDato, width, sortField) {
    return ({
      selector: row => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      /* sortFunction: caseInsensitiveSort, */
      reorder: true,
      width: width + "px",
      sortField: sortField,
      cell: (row) => {
        if (row[nomeDato] && Array.isArray(row[nomeDato])) {
          if (row[nomeDato][0] && Array.isArray(row[nomeDato][0])) {
            return (
              <div>
                {row[nomeDato].map((arr)=> arr.map((dato)=><div>{dato}</div>))}
              </div>
            )
          } else {
            return (
              <div>
                {row[nomeDato].map(dato=><div>{dato}</div>)}
              </div>
            )
          }          
        }
      }
    })
  }

  const colonnaApriElemento = function (nomeDato, labelDato, width, idSped, sortField, compact, conditionalCellStyles) {
    return ({
      selector: row => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      compact: compact ? true : false,
      width: width + "px",
      sortField: sortField,
      conditionalCellStyles: conditionalCellStyles,
      cell: (row) => <div className="rowitem"><ApriElementoDiLista id={row[idSped]} testo={row[nomeDato]} apriElemento={apriElemento} obsoleto={row["obsoleto"]}/></div>
     
    })
  }

  const columns = [
    colonnaApriElemento('nome', 'Nome', 200, 'id', false,false),
    arrayACapo("arrFornitori",'Fornitori',200,null),
    arrayACapo("arrBrands",'Brands',200,null),
    colonnaBoolean('rappresentante', 'Rappr', 50, "hail", 'hail', false, "scrittaColScuro","scrittaColChiaro",false,false),
    colonnaBoolean('warranty', 'Warr', 50, "hardware", 'hardware', false, "scrittaColScuro","scrittaColChiaro",false,false),
    colonnaBoolean('immagini', 'Imm', 50, "image", 'image', false, "scrittaColScuro","scrittaColChiaro",false,false),
    colonnaBoolean('ean', 'EAN', 50, "list", 'list', false, "scrittaColScuro","scrittaColChiaro",false,false),
    colonnaBoolean('customer', 'Customer', 50, "support_agent", 'support_agent', false, "scrittaColScuro","scrittaColChiaro",false,false),
    colonnaUniversale('note', 'Note', 300, true, "sm", true, false, false, null, false)
  ];

  return (
    <div
      className="h-100"
    >
      <DataTable
        data={rows}
        columns={columns}
        fixedHeader={false}
        fixedHeaderScrollHeight={"100px"}
        striped={false}
        progressPending={loading}
        noDataComponent={<h3 className='ma5 pa5'>Nessun contatto risponde alla tua ricerca.</h3>}
        progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
        pagination
        paginationRowsPerPageOptions={[10,50,200]}
        paginationPerPage={10}
        paginationComponentOptions={{ rowsPerPageText: '', rangeSeparatorText: 'di', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Seleziona tutti' }}
      />
      
    </div>
  )
}

export default ListaContatti;